import { TAG_TYPES } from 'types/services';

import { flowApi } from '.';

export const agendasFavoriteService = flowApi.injectEndpoints({
  endpoints: (builder) => ({
    setFavoriteAgenda: builder.mutation<void, string>({
      query: (id) => ({
        url: 'FavoriteUserAgendas',
        method: 'POST',
        params: {
          AgendaId: id,
        },
      }),
      invalidatesTags: [TAG_TYPES.AGENDAS_FAVORITE],
    }),
    removeFavoriteAgenda: builder.mutation<void, string>({
      query: (id) => ({
        url: `FavoriteUserAgendas/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG_TYPES.AGENDAS_FAVORITE],
    }),
  }),
});
export const { useSetFavoriteAgendaMutation, useRemoveFavoriteAgendaMutation } = agendasFavoriteService;
